/**
 * App Container actions
 */
export enum AppAction {
    InitStore = 'DSL_CHANGE/APP/INIT_STORE',
    SetLoading = 'DSL_CHANGE/APP/SET_LOADING',
    SetError = 'DSL_CHANGE/APP/SET_ERROR',
    SetSelectedTariffId = 'DSL_CHANGE/APP/SET_SELECTED_TARIFF_ID',
    SetTariffs = 'DSL_CHANGE/APP/SET_TARIFFS',
    SetCustomer = 'DSL_CHANGE/APP/SET_CUSTOMER',
}

/**
 * Error types
 */
export enum ErrorType {
    CmsConfig = 'CMS Config error',
    Jarvis = 'Jarvis error',
    Login = 'Login error',
}
